import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import "./banner.scss"

/**
 * 
<ul>
  <li>Furlough Group</li>
  <li>Oct 26, 2020</li>
  <li>@furlough</li>
</ul>
 * 
 */

class Banner extends React.Component {

  render() {
    return (
      <div className="banner text-center">
        {this.props.bannerimg &&
          <GatsbyImage image={getImage(this.props.bannerimg)} alt="banner" className="desktop-banner" />
        }
        <div  className={'saContainer'}>
          <h1 className={this.props.colorclass ? `mb-1 ${this.props.colorclass}` : `mb-1`}>{this.props.title ? <>{this.props.title}</> : 'Influencers' } <span></span></h1>
        </div>
      </div>
    );
  }
}

export default Banner
